import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "myheader"
};
const _hoisted_2 = {
  class: "header-wrap"
};
const _hoisted_3 = {
  class: "header-sub"
};
const _hoisted_4 = {
  class: "login-info"
};
import { ref, onMounted, reactive, watch } from "vue";
import { useRouter } from "vue-router";
import LoginRegister from "@/components/Home/LoginRegister.vue";
import DownloadQrcode from "./DownloadQrcode.vue";
import TrainDialog from "./TrainDialog.vue";
import { getCookie, removeCookie, getCookieCourse } from "@/utils/storage";
import { useStore } from "vuex";
// 将菜单项配置提取为常量，便于维护
export default /*@__PURE__*/_defineComponent({
  __name: 'Nav',
  setup(__props) {
    const websitename = ref(process.env.VUE_APP_PAGES_TITLE);
    const websitesub = ref(process.env.VUE_APP_SUB_TITLE);
    const router = useRouter();
    const store = useStore();
    const activeIndex = ref();
    const currentRealName = ref("");
    const state = reactive({
      activeName: "login",
      downloadQrcodeDialogShow: false,
      isLogin: false,
      trainDialogShow: false,
      activeType: 1
    });
    // 定义菜单项类型
    const menuItems = [{
      index: "1",
      path: "/",
      label: "首页"
    }, {
      index: "2",
      path: "/course",
      label: "精品课程"
    }, {
      index: "4",
      path: "/partner-course",
      label: "专业技术课程"
    }, {
      index: "3",
      path: "/news",
      label: "最新动态"
    }, {
      index: "5",
      path: "/customized",
      label: "定制课程"
    }, {
      index: "6",
      path: "/about",
      label: "温馨提示"
    }];
    // 提取路径归一化逻辑
    const normalizePath = path => {
      if (path.startsWith("/course/")) return "/course";
      if (path.startsWith("/partner-course/")) return "/partner-course";
      if (path.startsWith("/newsInfo")) return "/news";
      return path;
    };
    // 修复路径匹配逻辑，使用更精确的正则表达式
    const updateMenu = path => {
      const normalizedPath = normalizePath(path);
      const menuItem = menuItems.find(item => {
        // 构建正则：精确匹配路径，允许可选的尾部斜杠
        const pattern = item.path === "/" ? "^/$" : `^${item.path}/?$`;
        return new RegExp(pattern).test(normalizedPath);
      });
      activeIndex.value = menuItem ? menuItem.index : "";
    };
    // 监听路由变化并更新菜单选中状态
    watch(() => router.currentRoute.value.path, newPath => {
      updateMenu(newPath);
    });
    // 将路径映射简化
    const changePath = path => {
      router.push(path);
    };
    // 统一处理打开对话框的逻辑
    const openLogin = (type, activeType) => {
      store.commit("SET_LOGIN_REGISTER");
      state.activeName = type;
      state.activeType = activeType;
    };
    const openDownload = () => {
      state.downloadQrcodeDialogShow = true;
    };
    const openCenter = () => {
      router.push({
        path: "/center"
      });
    };
    const goHome = () => {
      router.push({
        path: "/"
      });
    };
    // 优化登录状态检查逻辑
    const checkLoginStatus = () => {
      try {
        const userInfoStr = getCookie();
        const token = sessionStorage.getItem("token");
        const courseOrderStr = getCookieCourse();
        // 如果有课程订单信息，则优先使用其中的 token
        if (courseOrderStr && courseOrderStr.length > 0) {
          try {
            const courseOrder = JSON.parse(courseOrderStr);
            if (courseOrder._u_t?.length > 0) {
              sessionStorage.setItem("token", courseOrder._u_t);
              state.isLogin = true;
              // 即使有 token，也尝试解析用户信息显示名称（如果后续逻辑需要）
              if (userInfoStr) {
                try {
                  const userInfo = JSON.parse(userInfoStr);
                  if (userInfo.realName) {
                    currentRealName.value = userInfo.realName;
                  }
                } catch (e) {
                  console.warn("User info parse error:", e);
                }
              }
              return;
            }
          } catch (e) {
            console.warn("Course order parse error:", e);
          }
        }
        // 否则检查用户信息和 token
        if (!userInfoStr || userInfoStr.length === 0 || !token) {
          state.isLogin = false;
          return;
        }
        // 设置用户信息
        if (userInfoStr) {
          try {
            const userInfo = JSON.parse(userInfoStr);
            if (userInfo.realName) {
              currentRealName.value = userInfo.realName;
              state.isLogin = true;
            } else {
              state.isLogin = true;
            }
          } catch (e) {
            console.error("User info parse error:", e);
            state.isLogin = false;
          }
        }
      } catch (error) {
        console.error("Error checking login status:", error);
        state.isLogin = false;
      }
    };
    const logout = () => {
      removeCookie();
      sessionStorage.clear();
      state.isLogin = false;
      goHome();
    };
    // 事件处理器保持简洁
    const updateLoginDialog = () => {
      store.commit("SET_LOGIN_REGISTER");
    };
    const updateLoginStatus = isLogon => {
      state.isLogin = isLogon;
    };
    const updateRealName = realName => {
      currentRealName.value = realName;
    };
    const updateDownloadDialog = dialogShow => {
      state.downloadQrcodeDialogShow = dialogShow;
    };
    const updateTrainDialog = dialogShow => {
      state.trainDialogShow = dialogShow;
    };
    onMounted(() => {
      updateMenu(router.currentRoute.value.path);
      checkLoginStatus();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "header-title",
        onClick: goHome,
        style: {
          "cursor": "pointer"
        }
      }, [_createElementVNode("div", null, _toDisplayString(websitename.value), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(websitesub.value), 1)]), !state.isLogin ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[0] || (_cache[0] = $event => openLogin('login', 1))
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("登录")])),
          _: 1
        }), _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[1] || (_cache[1] = $event => openLogin('login', 2))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("团体用户登录")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = $event => openLogin('register', 3))
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 注册 ")])),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_row, {
        key: 1
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, "欢迎，" + _toDisplayString(currentRealName.value), 1), _createElementVNode("span", {
          onClick: openCenter,
          class: "center"
        }, "[个人中心]"), _createElementVNode("span", {
          onClick: logout,
          class: "logout"
        }, "[退出]")])]),
        _: 1
      }))]), _createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        class: "myelmenu",
        mode: "horizontal",
        "background-color": "#009fe9",
        "text-color": "#ffffff",
        "active-text-color": "#ffffff"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, item => {
          return _createVNode(_component_el_menu_item, {
            key: item.index,
            index: item.index,
            onClick: $event => changePath(item.path)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
            _: 2
          }, 1032, ["index", "onClick"]);
        }), 64)), _createVNode(_component_el_menu_item, {
          index: "7",
          onClick: openDownload
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode(" 下载 APP ")])),
          _: 1
        })]),
        _: 1
      }, 8, ["default-active"])]), !_ctx.$store.state.HomeModule.loginRegisterDialogShow ? (_openBlock(), _createBlock(LoginRegister, {
        key: 0,
        "active-name": state.activeName,
        "active-type": state.activeType,
        onUpdateDialog: updateLoginDialog,
        onUpdateLogin: updateLoginStatus,
        onUpdateRealName: updateRealName
      }, null, 8, ["active-name", "active-type"])) : _createCommentVNode("", true), _createVNode(DownloadQrcode, {
        "show-dialog": state.downloadQrcodeDialogShow,
        onUpdateDialog: updateDownloadDialog
      }, null, 8, ["show-dialog"]), _createVNode(TrainDialog, {
        "show-dialog": state.trainDialogShow,
        onUpdateDialog: updateTrainDialog
      }, null, 8, ["show-dialog"])], 64);
    };
  }
});